import React from 'react';
import Conditional from '../../common/conditional';

import * as models from '../../../utils/models';
import * as utils from '../../../utils/utilities';

import css from './pdf.module.scss';


const PDFTablePage = (props: Pick<models.TableProps, 'columns' | 'data' | 'caption'>) => {
	return (
		<React.Fragment>
			<div className="table-responsive">
				<table className={css['pdf-table']}>
					<Conditional isVisible={!!props.caption}>
						<caption>{props.caption}</caption>
					</Conditional>
				
					<thead>
						<tr>
							{props.columns.map((column: models.Column) => (
								<th key={column.path + column.label} style={column.headerStyle}>{column.label}</th>
							))}
						</tr>
					</thead>

					<tbody>
						<Conditional isVisible={props.data.length > 0}>
							{props.data.map((item, index: number) => (
								<tr key={index}>
									{props.columns.map((column: models.Column) => (
										<td key={column.path + column.label} style={utils.renderStyle(item, column)}>
											{utils.renderCell(item, column, index)}
										</td>
									))}
								</tr>
							))}
						</Conditional>
					</tbody>
				</table>
				
				<Conditional isVisible={props.data.length === 0}>
					<div className="bg-light border p-1 m-2 text-center fw-bold fs-6">Nil</div>
				</Conditional>
			</div>
		</React.Fragment>
	);
};

export default PDFTablePage;
